














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import KendoDatePicker from '@/components/kendo-datepicker/kendo-datepicker.vue';
import {i18nMixin} from '@/modules/neodash/mixins';
import {maxDate, minDate} from '@/modules/neodash/model/constants/periodLimits';
import {MonthYear, Period} from '@/modules/neodash/model/types/interfaces/Period';
import {ITextValue} from '@/interfaces/key-value-interface';
import moment from 'moment';

@Component({
  name: 'MonthYearForm',
  components: {
    KendoDatePicker
  }
})
export default class MonthYearForm extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  public dateValue = new Date();
  public minLimitDate = minDate;
  public maxLimitDate = maxDate;

  @Prop({required: false})
  value: MonthYear;

  @Prop({required: true})
  label: string;

  @Prop({required: true})
  limits: Period;

  @Watch('limits')
  public updateLimits() {
    const {limits, dateValue} = this;
    const {initial, final} = limits;
    this.minLimitDate = new Date(initial.year, initial.month - 1);
    this.maxLimitDate = new Date(final.year, final.month - 1);

    if (!dateValue)
      return;

    const diffFromMin = moment(dateValue).diff(this.minLimitDate);
    if (diffFromMin < 0)
      this.emitNewValue({value: this.minLimitDate} as ITextValue<Date>);

    const diffFromMax = moment(dateValue).diff(this.maxLimitDate);
    if (diffFromMax > 0)
      this.emitNewValue({value: this.maxLimitDate} as ITextValue<Date>);
  }

  @Watch('value')
  public updateValues() {
    const {value} = this;
    if (!value)
      return;

    this.dateValue = new Date(value.year, value.month - 1);
  }

  public emitNewValue(obj: ITextValue<Date>): void {
    this.dateValue = obj.value;

    const {dateValue} = this;
    if (!dateValue)
      return;

    const newValue: MonthYear = {
      year: dateValue.getFullYear(),
      month: dateValue.getMonth() + 1
    };

    this.$emit('input', newValue);
    this.$emit('change', newValue);
  }

  public created() {
    this.updateValues();
    this.updateLimits();
  }
}
